// SVG path description specifies how the path should be drawn
function getPathDescription({
  pathRadius,
  counterClockwise,
  sizeRatio,
}: {
  pathRadius: number;
  counterClockwise: boolean;
  sizeRatio: number;
}) {
  const radius = pathRadius;
  const rotation = counterClockwise ? 1 : 0;

  // Move to center of canvas
  // Relative move to top canvas
  // Relative arc to bottom of canvas
  // Relative arc to top of canvas
  return `
        M ${50 * sizeRatio},${50 * sizeRatio}
        m 0,-${radius}
        a ${radius},${radius} ${rotation} 1 1 0,${2 * radius}
        a ${radius},${radius} ${rotation} 1 1 0,-${2 * radius}
      `;
}

function getDashStyle({
  counterClockwise,
  dashRatio,
  pathRadius,
}: {
  counterClockwise: boolean;
  dashRatio: number;
  pathRadius: number;
}) {
  const diameter = Math.PI * 2 * pathRadius;
  const gapLength = (1 - dashRatio) * diameter;

  return {
    // Have dash be full diameter, and gap be full diameter
    strokeDasharray: `${diameter}px ${diameter}px`,
    // Shift dash backward by gapLength, so gap starts appearing at correct distance
    strokeDashoffset: `${counterClockwise ? -gapLength : gapLength}px`,
  };
}
export function Path({
  sizeRatio,
  className,
  counterClockwise,
  dashRatio,
}: {
  sizeRatio: number;
  className?: string;
  counterClockwise: boolean;
  dashRatio: number;
}) {
  const pathRadius = 25 * sizeRatio;
  return (
    <path
      className={className}
      style={Object.assign({}, getDashStyle({ pathRadius, dashRatio, counterClockwise }))}
      d={getPathDescription({
        pathRadius,
        counterClockwise,
        sizeRatio,
      })}
      strokeWidth={50 * sizeRatio}
      fillOpacity={0}
    />
  );
}
